import React, { Component, Suspense, Fragment } from "react";
import { Route } from "react-router-dom";
import { Link } from "react-router-dom";
import Loading from "../../components/common/Loading";
import "./Home.css";

export default class Home extends Component {
  componentDidMount() {
    // console.log("THis Prop", this.props);
  }
  render() {
    return (
      <div className="homeWrapper">
        <div className="homeContainer">
          {this.props.isAuthenticated === undefined ? (
            <Loading />
          ) : (
            <Fragment>
              <div className="homeCol2 bannerLeft leftBg">
                <div className="bannerCtnr">
                  <div className="bannerHdngBlock">
                    <h1 className="headingLine margBtm">
                      {this.props.language.build}{" "}
                      <span>{this.props.language.virtual_com}</span>
                      {this.props.language.home_instavc_build}
                    </h1>
                  </div>
                  <div className="bannerPort margBtm">
                    {/* <img src="./images/banners/banner-new-second.jpg" alt="" /> */}
                  </div>
                  <div className="flexCol bannerHdngBlock">
                    <div className="inlineBlock">
                      <span>
                        {this.props.language.home_instavc_conference_platform}
                      </span>
                    </div>
                    <div className="inlineBlock">
                      <span className="oranclr">
                        {this.props.language.home_instavc_start_conference}
                      </span>
                    </div>
                    <div className="inlineBlock">
                      <span>{this.props.language.home_instavc_Hippa}</span>
                    </div>
                  </div>
                </div>
                {/* <div className="bannerFixedBlock">
                  
                </div> */}
              </div>
              <div className="homeCol2 brdrWLeft overflowFlexBox">
                <Suspense fallback={<Loading />}>
                  <Route
                    exact
                    path={this.props.path}
                    {...this.props}
                    component={this.props.component}
                  />
                </Suspense>
                {/* <div className="copyright">
                  {this.props.language.home_inclass_copyright}
                </div> */}
              </div>
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}
